export class GlobalConstants {

    //regex
    public static numberRegex: string = '^[+-]?([0-9]*[.])?[0-9]+$'
    public static nameRegex: string = '[a-zA-Z\u0600-\u06FF -]*'
    public static emailRegex: string = '[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,}'
    public static phoneRegex: string = '^(?:\\+966|0)5\\d{8}$'
    public static passwordRegex: string = '^.{6,50}$'
    public static colorRegex: string = '(?:#|0x)(?:[a-f0-9]{3}|[a-f0-9]{6})\\b|(?:rgb|hsl)a?\\([^\)]*\\)'
    // public static datetimeRegex: string = '/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/'

    public static passwordConditions = [
        { message: 'يجب أن تحتوي كلمة المرور على 6 حروف على الأقل.', regex: "^[A-Za-z]{6,}$", status: false },
        { message: 'لا يمكن أن تحتوي كلمة المرور على أكثر من 50 حرفًا.', regex: "^[A-Za-z]{0,50}$", status: false },
         ];

    // date format
    public static MY_DATE_FORMATS = {
        parse: {
            dateInput: 'DD/MM/YYYY',
        },
        display: {
            dateInput: 'DD/MM/YYYY',
            monthYearLabel: 'MMMM YYYY',
            dateA11yLabel: 'LL',
            monthYearA11yLabel: 'MMMM YYYY'
        },
    };

    // datetime format
    public static MY_DATETIME_FORMATS = {
        parse: {
            dateInput: 'YYYY-MM-DD hh:mm:ss',
        },
        display: {
            dateInput: 'YYYY-MM-DD hh:mm:ss',
            monthYearLabel: 'MMM YYYY',
            dateA11yLabel: 'LL',
            monthYearA11yLabel: 'MMMM-YYYY',
        },
    };
}